import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const store = new Map<string, number>();

export function useScrollRestoration() {
  const loc = useLocation();
  useEffect(() => {
    const main = document.querySelector<HTMLElement>(".app-shell > .main");
    if (!main) return;
    const saved = store.get(loc.key) ?? 0;
    main.scrollTop = saved;
    const on = () => store.set(loc.key, main.scrollTop);
    main.addEventListener("scroll", on, { passive: true });
    return () => main.removeEventListener("scroll", on);
  }, [loc.key]);
}
